import React, { useState, useEffect, useRef } from 'react';
import '../component.scss';
import SearchDropdownVirtualizedList from './SearchDropdownVirtualizedList';
import SearchDropdownMultiselectOpenList from './SearchDropdownMultiselectOpenList';
import {
  beautyReefHotelList,
  noWindHotelList,
} from '../../widgets/SearchTourForm/constants/EgypetCollectionHotelsList';
import { MdFilterAlt } from 'react-icons/md';
import RecomendHotels from '../../widgets/SearchTourForm/components/RecomendHotels';

const SearchHotelsWidgetOpen = ({
  value,
  items,
  label,
  title = '',
  width = 220,
  onChoose,
  onChooseCollection,
  hasFilter = false,
  buttonReset = false,
  onReset,
  recomend,
  onRecomend,
  isHidden = false,
  onHide,
  cssClass = '',
  country,
  recomendList,
  onSetWithReviews,
}) => {
  const [wasChanged, setWasChanged] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isHotelsCollection, setIsHotelsCollection] = useState(false);
  const [hotelsCollection, setHotelsCollection] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const popupRef = useRef(null);

  const hotelsCollectionOptions = [
    {
      id: 2,
      name: 'Отели без ветра зимой',
      recomend: false,
    },
    {
      id: 3,
      name: 'Отели с красивым рифом',
      recomend: false,
    },
  ];

  const setValue = (val) => {
    onChoose(val);
    setWasChanged(val.length ? true : false);
  };

  const setCollectionValue = (value) => {
    let newCollection = [...hotelsCollection];
    if (hotelsCollection.includes(value)) {
      let index = newCollection.indexOf(value);
      newCollection.splice(index, 1);
    } else {
      newCollection.push(value);
    }
    setHotelsCollection(newCollection);
    let hotelsIdsValuesList = [];

    if (newCollection.includes(2)) {
      hotelsIdsValuesList = [...hotelsIdsValuesList, ...noWindHotelList];
    }
    if (newCollection.includes(3)) {
      hotelsIdsValuesList = [...hotelsIdsValuesList, ...beautyReefHotelList];
    }
    onChooseCollection(hotelsIdsValuesList);

    setWasChanged(value.length ? true : false);
  };

  const reset = () => {
    setSearchTerm('');
    setFilteredOptions([]);
    setHotelsCollection([]);
    onRecomend(false);
    onSetWithReviews(false);
    onReset();
  };

  const toggleHideTouroperator = (e) => {
    const isHide = e.target.checked;
    onHide(isHide);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    const filtered = items.filter((option) =>
      option.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredOptions(filtered);
    if (value === '') {
      setFilteredOptions([]);
    }
  };

  const toggleHotelsCollection = (e) => {
    setIsHotelsCollection(!isHotelsCollection);
    reset();
  };

  let items_fix = items;
  if (filteredOptions.length) {
    items_fix = filteredOptions;
  }
  if (isHotelsCollection) {
    items_fix = hotelsCollectionOptions;
  }

  return (
    <div
      className={`search-widget-open ${wasChanged} ${cssClass}`}
      style={{ width: width, position: 'relative' }}
    >
      <div
        style={{
          top: '-17px',
          color: '#777',
          textTransform: 'uppercase',
          fontSize: '10px',
          marginLeft: '10px',
        }}
      >
        {'Всего отелей'}: {items_fix.length}
      </div>
      <div
        style={{
          position: 'absolute',
          left: '130px',
          top: '0px',
          color: '#3e6a3a',
          textTransform: 'uppercase',
          fontSize: '10px',
          fontWeight: 700,
        }}
      >
        {isHotelsCollection ? 'Выберите группу отелей' : title}
      </div>
      {isHidden ? (
        <div
          style={{
            top: '-17px',
            color: '#777',
            textTransform: 'uppercase',
            fontSize: '10px',
            marginLeft: '8px',
          }}
        >
          <label>
            <input
              type="checkbox"
              style={{ verticalAlign: 'sub', marginRight: '5px' }}
              onClick={toggleHideTouroperator}
            />
            <span>Скрыть</span>
          </label>
        </div>
      ) : null}
      <div
        style={{ paddingLeft: '10px', display: 'flex', gap: '10px' }}
        className="filterbar"
      >
        {hasFilter && (
          <input
            type="text"
            placeholder={label}
            className="filterinput"
            style={{ width: 300, height: '30px' }}
            value={searchTerm}
            onChange={handleInputChange}
          />
        )}
        {country == 1 && (
          <span
            className={`filter-button ${isHotelsCollection}`}
            onClick={toggleHotelsCollection}
          >
            <MdFilterAlt />
          </span>
        )}
        {recomendList.length > 0 ? (
          <RecomendHotels recomend={recomend} onChoose={onRecomend} />
        ) : null}
        {buttonReset && (
          <button className="btn btn_reset" onClick={reset}>
            Сбросить
          </button>
        )}
      </div>
      <div
        className="search-widget-open__wrap"
        ref={popupRef}
        style={{ width: '100%' }}
      >
        {isHotelsCollection ? (
          <SearchDropdownMultiselectOpenList
            value={hotelsCollection}
            items={hotelsCollectionOptions}
            onChoose={setCollectionValue}
          />
        ) : (
          <SearchDropdownVirtualizedList
            value={value}
            items={items_fix}
            onChoose={setValue}
          />
        )}
      </div>
    </div>
  );
};

export default SearchHotelsWidgetOpen;
